export default __webpack_public_path__ + "static/media/Snd_C9.5803e108.mp3";